export const USER = '/api/user/profile';
